import { render, staticRenderFns } from "./NominationForm.vue?vue&type=template&id=214719c7"
import script from "./NominationForm.vue?vue&type=script&lang=js"
export * from "./NominationForm.vue?vue&type=script&lang=js"
import style0 from "./NominationForm.vue?vue&type=style&index=0&id=214719c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports